import ProductsError from './ProductsError.js'

export default class GetPaymentAdProductsError extends ProductsError {}
